/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Album interface.
 */
export function instanceOfAlbum(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if ((!('imageUrl' in value) && !('image_url' in value)) || (value['imageUrl'] === undefined && value['image_url'] === undefined))
        return false;
    return true;
}
export function AlbumFromJSON(json) {
    return AlbumFromJSONTyped(json, false);
}
export function AlbumFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'imageUrl': json['image_url'],
    };
}
export function AlbumToJSON(json) {
    return AlbumToJSONTyped(json, false);
}
export function AlbumToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'image_url': value['imageUrl'],
    };
}
